import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  loading: {
    display: 'flex',
    justifyContent: 'space-around'
  },
}));
